import type { ReactNode } from 'react'

export type EmptyStateVariant = 'not-found' | 'signin' | 'empty-favorites' | 'empty-records'

export interface EmptyStateProps {
  title: string
  description?: ReactNode
  action?: ReactNode
  variant?: EmptyStateVariant
  className?: string
}

const ILLUSTRATION_SRC: Record<EmptyStateVariant, string> = {
  'not-found': '/illustrations/reindeer-not-found.svg',
  signin: '/illustrations/reindeer-signin.svg',
  'empty-favorites': '/illustrations/reindeer-empty-favorites.svg',
  'empty-records': '/illustrations/reindeer-empty-records.svg',
}

export function EmptyState({
  title,
  description,
  action,
  variant = 'not-found',
  className = '',
}: EmptyStateProps) {
  const cls =
    `flex flex-col items-center justify-center gap-3 py-12 text-center ${className}`.trim()

  return (
    <div className={cls}>
      <img
        src={ILLUSTRATION_SRC[variant]}
        alt=""
        aria-hidden="true"
        draggable={false}
        className="mb-1 h-24 w-24"
      />
      <p className="text-base font-medium text-[var(--xr-text-primary)]">{title}</p>
      {description && (
        <p className="max-w-sm text-sm text-[var(--xr-text-secondary)]">{description}</p>
      )}
      {action}
    </div>
  )
}
